import Vue from "vue";
import getters from "./getters";
import actions from "./actions";
import * as types from "./../action-types";
import { get, set, cloneDeep } from "lodash";

const vClone = (object) => Vue.util.extend({}, cloneDeep(object));

const initialState = () =>
  cloneDeep({
    helpers: {
      isISTOpen: false,
    },
    countries: {},
    reasons: [],
    groups: [],
    products: [],
    retailers: [],
    messages: {},
    markets: {},
    permissions: {},
    feature_flags: {},
    roles: {},
    current_authorization: {},
    piiAuthorizationStatus: "",
  });

const mutations = {
  [types.FETCH_COUNTRIES.SUCCESS](state, data) {
    let snameCountryDict = get(data, "countries", []).reduce(
      (countries, country) => {
        countries[country["sname"]] = country;
        return countries;
      },
      {}
    );
    state.countries = snameCountryDict;
  },
  [types.FETCH_COUNTRY_STATES.SUCCESS](state, { data, countryCode }) {
    let states = get(data, "states", []).reduce((states, state) => {
      states[state.code] = state;
      return states;
    }, {});
    let countries = vClone(state.countries);
    countries[countryCode].states = states;
    state.countries = countries;
  },
  [types.FETCH_COUNTRIES.ERROR](state, error) {
    console.info("FETCH_COUNTRIES.ERROR", error);
  },
  [types.FETCH_COUNTRY_STATES.ERROR](state, error) {
    console.info("FETCH_COUNTRY_STATES.ERROR", error);
  },
  [types.FETCH_REASONS.SUCCESS](state, data) {
    state.reasons = data.reasons;
    state.groups = data.groups;
  },
  [types.FETCH_REASONS.ERROR](state, error) {
    console.info("FETCH_REASONS.ERROR", error);
  },
  [types.FETCH_PRODUCTS.SUCCESS](state, data) {
    state.products = data;
  },
  [types.FETCH_PRODUCTS.ERROR](state, error) {
    console.info("FETCH_PRODUCTS.ERROR", error);
  },
  [types.FETCH_MARKETS.SUCCESS](state, data) {
    state.markets = data.markets;
  },
  [types.FETCH_MARKETS.ERROR](state, error) {
    console.info("FETCH_MARKETS.ERROR", error);
  },
  [types.FETCH_RETAILERS.SUCCESS](state, data) {
    state.retailers = data;
  },
  [types.FETCH_RETAILERS.ERROR](state, error) {
    console.info("FETCH_RETAILERS.ERROR", error);
  },
  [types.FETCH_PERMISSIONS.SUCCESS](state, data) {
    state.permissions = data;
  },
  [types.FETCH_PERMISSIONS.ERROR](state, error) {
    console.info("FETCH_PERMISSIONS.ERROR", error);
  },
  [types.FETCH_FEATURE_FLAGS.SUCCESS](state, data) {
    state.feature_flags = data;
  },
  [types.FETCH_FEATURE_FLAGS.ERROR](state, error) {
    console.info("FETCH_FEATURE_FLAGS.ERROR", error);
  },
  [types.FETCH_ROLES.SUCCESS](state, data) {
    state.roles = data;
  },
  [types.FETCH_ROLES.ERROR](state, error) {
    console.info("FETCH_ROLES.ERROR", error);
  },
  setCurrentAuthorization(state, auth) {
    state.current_authorization = auth || {};
  },
  sendMessage(state, { id, msg }) {
    set(state.messages, id, msg);
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
  setPiiAuthorizationStatus(state, value) {
    state.piiAuthorizationStatus = value;
  },
};

// Add non asynchronous actions
Object.assign(actions, {});

export default {
  state: initialState(),
  mutations,
  getters,
  actions,
  namespaced: true,
};
